var processInclude = require("base/util");

if ($("#cbt-site-location").length) {
    processInclude(require("cbt/components/cbtStorePage"));
}

$(document).ready(function () {
    processInclude(require("coremh/components/tabCarousel"));
    processInclude(require("corepd/layout"));
    processInclude(require("./components/editorialAssets"));
    processInclude(require("./components/contentTilesCarousel"));
    processInclude(require("./components/timelineCarousel"));
    processInclude(require("./components/reservation"));
    processInclude(require("./components/parallaxImageText"));
});

require("coremh/thirdParty/css3-animate-it.min");
